// extracted by mini-css-extract-plugin
module.exports = {"Page":"CustomerDetails_Page__vwZBH"};